import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { DEPORTES_LISTA } from "../data/deportes";

export default function Categories() {
    const { currentUser } = useAuth();

    return (
        <section id="portafolio">
            <div className="categories-head">
                <h2 className="display">Portafolio</h2>
                <span className="mono">{String(DEPORTES_LISTA.length).padStart(2, "0")} disciplinas</span>
            </div>

            <div className="categories">
                {DEPORTES_LISTA.map((d, i) => (
                    <div
                        key={d.id}
                        className={`category category-${d.id} ${d.imagen ? "" : "category-sin-foto"}`}
                        style={d.imagen ? { backgroundImage: `url(${d.imagen})` } : undefined}
                    >
                        {/* Toda la tarjeta es clicable (antes solo el botón, y en escritorio estaba oculto) */}
                        <Link to={`/deporte/${d.id}`} className="category-link">
                            <span className="category-num mono">{String(i + 1).padStart(2, "0")}</span>
                            <h3 className="display">{d.nombre}</h3>
                            <p>{d.lema}</p>
                            <span className="category-cta">Ver galería →</span>
                        </Link>
                        {currentUser && (
                            <Link to={`/admin/deporte/${d.id}`} className="category-admin">Gestionar</Link>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
}
